import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { getMetaConversationName } from 'app/utils/conversation';
import { ConversationDetails } from 'components/conversationsOverview/components/ConversationDetails';
import { SearchResult } from '../../../../result/searchResult';
import styles from './conversationResult.module.scss';
import { convertHitToMetaConversation } from './utils/convertHitToMetaConversation';
/**
 * Represents a component that is used to render the conversation search result
 * item
 */
export const ConversationResult = ({ className, hit, isSelectable, isSelected, onRowSelect, onRowClick, }) => {
    const isEventTargetExcluded = useCallback(({ target }) => {
        const targetEl = target;
        return (targetEl.tagName === 'LABEL' || targetEl.matches('[type="checkbox"]'));
    }, []);
    const handleClick = useCallback((event) => {
        if (isEventTargetExcluded(event)) {
            return;
        }
        onRowClick(hit);
    }, [hit, isEventTargetExcluded, onRowClick]);
    const metaConversation = convertHitToMetaConversation(hit);
    const title = getMetaConversationName(metaConversation);
    return (_jsx(SearchResult, { className: className, onClick: handleClick, content: _jsxs("div", Object.assign({ className: styles.conversationSummaryWrapper }, { children: [isSelectable && (_jsx(Checkbox, { onChange: () => onRowSelect(hit), checked: isSelected, id: hit.id, name: hit.id })), _jsx(ConversationDetails, { metaConversation: metaConversation, conversationName: title, showMessageCount: true, showTags: true, tags: hit.tags, conversationUrl: `/conversation/${hit.numeric_id}`, linkToConversation: false })] })) }));
};
